<template>
    <div
        v-if="isPdfPreview"
        :style="typeof value === 'boolean' ? 'line-height: 1;' : ''"
        :class="[className, 'resize-heigh']"
    >
        {{ getFormattedValue(model) }}
    </div>
    <textarea v-else-if="multiline" v-model="model" :class="className" :rows="rows" :maxlength="maxLength" />
    <input
        v-else
        v-model="model"
        :type="inputType"
        :class="className"
        :value="checkedValue"
        :placeholder="placeHolder"
        :auto-complete="autoComplete"
    />
</template>
<script>
export default {
    // eslint-disable-next-line vue/no-reserved-component-names
    name: 'Input',
    props: {
        // eslint-disable-next-line vue/require-prop-types
        value: {
            // type: [Number, String, Boolean],
            required: true,
        },
        inputType: {
            type: String,
            default: 'text',
        },
        className: {
            type: String,
            default: '',
        },
        placeHolder: {
            type: String,
            default: '',
        },
        autoComplete: {
            type: String,
            default: '',
        },
        /**
         * Radio value
         */
        checkedValue: {
            type: [Boolean, Number],
            default: null,
        },
        multiline: {
            type: Boolean,
            default: false,
        },
        rows: {
            type: Number,
            default: 4,
        },
        maxLength: {
            type: Number,
            default: 10000,
        },
    },
    data() {
        return {
            isPdfPreview: false,
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
    },
    watch: {},
    mounted() {
        this.isPdfPreview = this.$root.inPdfPreviewForm(this.$el)
    },
    methods: {
        onInput(event) {
            this.$emit('input', event.target.value)
        },
        onChange(event) {
            this.$emit('change', event.target.value)
        },
        getFormattedValue() {
            if (
                this.value == null ||
                this.value == undefined ||
                (typeof this.value !== 'boolean' && this.value == '')
            ) {
                return 'No value'
            }

            if (this.value === true || this.value === false) {
                return this.value ? '✔' : '✖'
                //  return this.value ? 'V' : 'X'
            }

            return this.value
        },
    },
}
</script>

<style lang="scss" scoped>
.resize-height {
    resize: both;
    overflow: auto;
}
</style>
